










































import Webview from '@/webview';

import { IgetDoctorQueryHospitalListParam, IgetDoctorQueryHospitalListHospitalList } from '@/store/specialist/index.d';

import { dispatchGetHospitalList } from '@/store/specialist';
import Component from 'vue-class-component';
import SearchFilter from '@/pages/DoctorSearch/SearchFilter.vue';
import { FILTER_TYPE_ENUM, IfilterVaule, ItreeSelectItemChild } from '@/pages/DoctorSearch/SearchFilter';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    SearchFilter
  }
})
export default class HospitalList extends Webview {
  FILTER_TYPE_ENUM = FILTER_TYPE_ENUM;

  conditions: IfilterVaule = {};

  defaultDepartmentId = '';

  loading = false;

  finished = false;

  pageNo = 0;

  hospitalList: IgetDoctorQueryHospitalListHospitalList[] = [];

  get telescopeMap() {
    return this.$route.meta.telescopeMap;
  }

  @Watch('conditions', { deep: true })
  watchConditions() {
    this.clearSearchResult();
    this.fetchHospitalList();
  }

  clearSearchResult() {
    this.hospitalList.length = 0;
    this.finished = false;
    this.loading = false;
    this.pageNo = 0;
  }

  async fetchHospitalList() {
    const { id, level, parentId } = (this.conditions[FILTER_TYPE_ENUM.CITY] as ItreeSelectItemChild) || {};
    const [hospitalType] = Object.values(this.conditions[FILTER_TYPE_ENUM.HOSPITALS_TYPE] || {});

    const searchParams: IgetDoctorQueryHospitalListParam = {
      regionType: level as number,
      regionId: (parentId || id) as string,
      hospitalType,
      pageNo: this.pageNo += 1,
      pageSize: 20
    };

    if (!searchParams.regionId) {
      delete searchParams.regionType;
      delete searchParams.regionId;
    }

    this.loading = true;

    const { hospitalList = [], total = 0 } = await dispatchGetHospitalList(this.$store, searchParams);

    this.hospitalList.push(...hospitalList);

    this.finished = hospitalList.length >= total;

    this.loading = false;
  }

  getLocation(locationInfo: ItreeSelectItemChild) {
    const location = locationInfo;
    this.$set(this.conditions, `${[FILTER_TYPE_ENUM.CITY]}`, {
      ...location
    });
  }

  linkHospitalDetail(id: number) {
    this.telescope.trackEvent({
      trackId: this.constant.CLICK_EXPERT_CONSULTATION_HOSPITAL_DOCTOR_SELECT,
      custom: { id }
    });
    this.telescope.trackEvent({
      trackId: this.constant.CLICK_EXPERT_CONSULTATION_HOSPITAL_HOME
    });
    this.$router.push(`${this.constant.HOSPITAL_DETAIL}/${id}`);
  }
}
